import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, Tabs } from 'antd';
import FormHeader from '../../components/atoms/FormHeader';
import { Spin } from 'antd';
import query from 'query-string';
import axios from 'axios'
import './styles.scss';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { ArrowRightOutlined } from "@ant-design/icons";
import PreparedCheckList from './checkList';
import api from "../../utils/apiClient";
import { HandleServerError } from "../../utils/serverErrorHandler";

const { TabPane } = Tabs;


const QuestionForm = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formDetails, setFormDetails] = useState(location.state && location.state.topicDetails ? location.state.topicDetails : {});
  const [params, setParams] = useState({});
  const [data, setData] = useState([]);
  const [sortedData, setSortedData] = useState([])
  const [recordingData, setRecordingData] = useState("")
  const [showModal, setShowModal] = useState(false);

  const [tab, setTab] = useState("checkList")
  const [checkListData, setCheckListData] = useState([]);
  const [checkListLoading, setCheckListLoading] = useState(false);

  function calculateDurationFromTimeString(timeString) {
  if (isEmpty(timeString) || timeString == null) {
    return 0;
  }

  const timeParts = timeString.split(' ');

  // safely extract
  const hours = timeParts[0]?.includes('h') ? parseInt(timeParts[0].replace('h', ''), 10) : 0;
  const minutes = timeParts[1]?.includes('m') ? parseInt(timeParts[1].replace('m', ''), 10) : 0;
  const seconds = timeParts[2]?.includes('s') ? parseInt(timeParts[2].replace('s', ''), 10) : 0;

  return (hours * 3600) + (minutes * 60) + seconds;
}


  useEffect(() => {
    setParams(query.parse(location.search));
  }, [location.search]);


  const fetchCheckListData = () => {
      setCheckListLoading(true);
      setCheckListData([])
      api.get(`/spinozaService/api/spinoza/v2/prepared/checklist/${params.crnId}`, {},{
          Authorization: `Bearer ${location?.state?.token}`
      }).then((response) => {
          setCheckListLoading(false);
          setCheckListData(response?.data?.responseData)
      }).catch((err) => {
          HandleServerError(err);
          setCheckListLoading(false);
      });
  }

  const fetchCallAnalyticsData= ()=>{
    setLoading(true);
    axios.get(`https://meucci.bricknbolt.com/api/meucci/v2/callHistory/${params.crnId}`)
    .then(res=>{
      setData([...res?.data?.responseData])
    })
    .catch(err=>console.log(err))
    .finally(e=>setLoading(false))
  }

  useEffect(()=>{
    if(params.crnId){
      if(tab=="checkList"){
        fetchCheckListData()
      }else{
        fetchCallAnalyticsData()
      }
    }
  },[params,tab])

  useEffect(()=>{
    if(!isEmpty(data)){
      let temp = data?.sort((a, b) => calculateDurationFromTimeString(b.call_duration) - calculateDurationFromTimeString(a.call_duration));
      let tempSortedData = {}
      temp.forEach(t=>{
        if(tempSortedData[t.date])
          tempSortedData[t.date].push(t)
        else
          tempSortedData[t.date] = [t]
      })
      let p = []
      Object.keys(tempSortedData).sort((a,b)=>{
        return new Date(b)-new Date(a)
      }).forEach(t=>{
        p.push(...tempSortedData[t])
      })
      setSortedData(p)
    }
  },[data])

  
  return (
    <>
      <div>
        <FormHeader headerTitle={formDetails.description} headerLeftClick={() => {
          navigate(-1);
        }} />

        <section style={{padding:'1rem',marginTop:'-30px'}}>
            <Tabs defaultActiveKey={tab} onChange={(e)=>{
              setTab(e)
            }}>
              <TabPane tab="Prepared Checklist" key="checkList">
                <Spin spinning={checkListLoading}>
                  <PreparedCheckList 
                    // tabName ={tab} 
                    // crnId ={params?.crnId}
                    // token = {location?.state?.token}
                    checkListData={checkListData}
                  />
                </Spin>
              </TabPane>
              <TabPane tab="Call Analytics" key="analytics">
                <Spin spinning={loading}>
              {sortedData.length ? sortedData?.map((t,i)=>
                <>
                {(i === 0 || (
   i !== 0 && 
   moment(sortedData[i].date).format("YYYY-MM-DD") !== moment(sortedData[i-1].date).format("YYYY-MM-DD")
)) ? (
  <div style={{marginLeft:"1rem", fontWeight:500, marginTop: i!==0 ? '1rem' : "unset"}}>
    {t.date ? moment(t.date).format("DD MMMM, YYYY") : "-"}
  </div>
) : null}

                  <div style={{ border:"1px solid #e8dddc", borderRadius:"6px", margin:"0.5rem 1rem"}} onClick={()=>{
                    setRecordingData(t);
                    setShowModal(true);
                  }}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                      <div style={{padding:"1rem", display:"flex"}}>
                        <div style={{fontWeight:500}}>Time : &nbsp;</div>{t.time}
                      </div>
                      <div style={{marginRight:"1rem"}}><ArrowRightOutlined /></div>
                    </div>
                  </div>
                </>
              ) : 
              <div style={{position:"relative", height:"80vh"}}>
                <div style={{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", fontWeight:500, fontSize:"19px", color:'gray'}}>
                  No Data
                </div>
              </div>
              }
                </Spin>
              </TabPane>
            </Tabs>
        </section>

        <Modal
          title="Call Details"
          centered
          open={showModal}
          onOk={() => setShowModal(false)}
          onCancel={() => {
            setShowModal(false)
            let audioPlayer = document.getElementById('audioPlayer')
            audioPlayer.pause()
            audioPlayer.currentTime=0
          }}
          cancelText
          style={{textAlign:"center"}}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{padding:".5rem 2rem", display:"flex"}}>
              <div style={{fontWeight:500}}>Agent Name : &nbsp;</div>{recordingData.agentName}
            </div>
            <div style={{padding:".5rem 2rem", display:"flex"}}>
              <div style={{fontWeight:500}}>Time : &nbsp;</div>{recordingData.time}
            </div>
            <div style={{padding:".5rem 2rem", display:"flex"}}>
              <div style={{fontWeight:500}}>Duration : &nbsp;</div>{recordingData.call_duration}
            </div>
            <div style={{padding:".5rem 2rem 1rem 2rem", display:"flex"}}>
              <div style={{fontWeight:500}}>Call Type : &nbsp;  </div>{recordingData.callType}
            </div>
            <audio controls id='audioPlayer' key={recordingData?.public_call_recording}>
                <source src={recordingData?.public_call_recording} type="audio/mpeg" />
                <source src={recordingData?.public_call_recording} type="audio/ogg" />
                Your browser does not support the audio element.
            </audio>
          </div> 
        </Modal>
      </div>
    </>
  )
};

export default QuestionForm;